import React, {useCallback} from "react";
import {EmbedProviderProps} from "./EmbedProviders";
import {ensureScriptTag} from "./tagManager";
export function ContriblyContributeV2({oembed}: EmbedProviderProps) {

  const ref = useCallback((element: HTMLDivElement|null) => {
     if(element) {
      if ((window as any).contriblyContributeInitialized) {
        if((typeof (window as any).setupContriblyContributeWiget !== 'undefined')){
          (window as any).setupContriblyContributeWiget();
        }
      } else {
        (window as any).Contribly = (window as any).contriblyContributeInitialized = true;
        ensureScriptTag({
          src: 'https://s3-eu-west-1.amazonaws.com/contribly-widgets/contribute/contribute-tickaroo.js',
          async: true,
          onload: () => (window as any).setupContriblyContributeWiget()
        });
      }
    }
  }, [])

  return <div className="tik4-we-contribly" ref={ref} dangerouslySetInnerHTML={{__html: oembed.html || ""}} />
}

export default ContriblyContributeV2
